type SkeletonVariant =
  | 'project-list'
  | 'project-detail'
  | 'endpoint-list'
  | 'endpoint-detail'
  | 'share-view'
  | 'analytics';

function ProjectListSkeleton() {
  return (
    <div className="animate-pulse space-y-4 py-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="h-24 bg-base-300 rounded-box" />
      ))}
    </div>
  );
}

function ProjectDetailSkeleton() {
  return (
    <div className="min-h-screen bg-base-200">
      <div className="bg-base-100 border-b border-base-300">
        <div className="max-w-7xl mx-auto px-4 py-6 animate-pulse">
          <div className="h-4 w-32 bg-base-300 rounded-field mb-4" />
          <div className="h-8 w-64 bg-base-300 rounded-field" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8 animate-pulse space-y-6">
        <div className="h-20 bg-base-300 rounded-box" />
        <div className="h-10 w-48 bg-base-300 rounded-field" />
        <div className="space-y-3">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-16 bg-base-300 rounded-box" />
          ))}
        </div>
      </div>
    </div>
  );
}

function EndpointListSkeleton() {
  return (
    <div className="animate-pulse space-y-3 py-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="h-16 bg-base-300 rounded-box" />
      ))}
    </div>
  );
}

function EndpointDetailSkeleton() {
  return (
    <div className="min-h-screen bg-base-200">
      <div className="bg-base-100 border-b border-base-300">
        <div className="max-w-7xl mx-auto px-4 py-6 animate-pulse">
          <div className="h-4 w-48 bg-base-300 rounded-field mb-4" />
          <div className="h-8 w-72 bg-base-300 rounded-field mb-2" />
          <div className="h-4 w-56 bg-base-300 rounded-field" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8 animate-pulse">
        <div className="flex gap-4 mb-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-8 w-24 bg-base-300 rounded-field" />
          ))}
        </div>
        <div className="h-64 bg-base-300 rounded-box" />
      </div>
    </div>
  );
}

function ShareViewSkeleton() {
  return (
    <div className="min-h-screen bg-base-200">
      <div className="bg-base-100 border-b border-base-300">
        <div className="max-w-7xl mx-auto px-4 py-6 animate-pulse">
          <div className="h-8 w-48 bg-base-300 rounded-field mb-2" />
          <div className="h-4 w-32 bg-base-300 rounded-field" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8 animate-pulse space-y-6">
        <div className="h-20 bg-base-300 rounded-box" />
        <div className="h-6 w-32 bg-base-300 rounded-field" />
        <div className="space-y-3">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-16 bg-base-300 rounded-box" />
          ))}
        </div>
      </div>
    </div>
  );
}

function AnalyticsSkeleton() {
  return (
    <div className="card bg-base-100 mb-6 p-6 animate-pulse">
      <div className="h-6 w-32 bg-base-300 rounded-field mb-6" />
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-16 bg-base-300 rounded-box" />
        ))}
      </div>
      <div className="h-48 bg-base-300 rounded-box" />
    </div>
  );
}

export function Skeleton({ variant }: { variant: SkeletonVariant }) {
  switch (variant) {
    case 'project-list':
      return <ProjectListSkeleton />;
    case 'project-detail':
      return <ProjectDetailSkeleton />;
    case 'endpoint-list':
      return <EndpointListSkeleton />;
    case 'endpoint-detail':
      return <EndpointDetailSkeleton />;
    case 'share-view':
      return <ShareViewSkeleton />;
    case 'analytics':
      return <AnalyticsSkeleton />;
  }
}
